import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#0055C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.3324 18.6934V16.4786H10.8703C11.0394 15.709 12.3719 14.6017 13.0478 13.9821C14.6433 12.5369 16.0885 11.5046 16.0885 9.23322C16.0885 6.53035 13.8922 5.21661 11.565 5.21661C9.78171 5.21661 8.59919 5.74227 7.32275 6.84966L8.71188 8.68931C9.03093 8.3327 9.83806 7.488 11.0018 7.488C12.447 7.488 13.1978 8.40757 13.1978 9.55279C13.1978 10.8292 12.2404 11.749 11.3584 12.5184C9.59389 14.0575 8.07354 15.409 7.73571 16.9482V18.6937H16.3324V18.6934Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLine2);
export { ForwardRef as ReactComponent };
